import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  amountFormatter,
  getAllProperties,
  getWatermarkedImgixUrl,
} from "services";
import DashboardLayout from "./DashboardLayout";
import PropertyCard from "../../propertyList/PropertyCard";
import { DateTime } from "luxon";
import PrivatePropertyCard from "../../postYourProperty/listingPage/PrivatePropertyCard";

export const ShortlistedSection = () => {
  const [propertiesData, setPropertiesData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);
  const [noMoreData, setNoMoreData] = useState(false);
  const shortlistedProperties = useSelector((state: any) => {
    return state.auth?.user?.profile?.meta?.shortlisted_properties;
  });

  const getProperties = async (pageToFetch: number) => {
    if (isFetchingNextPage || noMoreData) return;
    setIsFetchingNextPage(true);

    const data: any = await getAllProperties({
      apiConfig: {
        includeRelations: [
          "city",
          "sub_asset_type",
          "bank",
          "images",
          "locality",
          "sub_asset_type_images",
        ],
        includeMutations: ["state", "asset", "images"],
        includeFacets: false,
      },
      limitBy: {
        per_page: 5,
        page: pageToFetch,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [
        {
          attribute: "uuid",
          op: "in",
          value: shortlistedProperties ? shortlistedProperties : [],
        },
      ],
    });

    if (data.data && data.data.length > 0) {
      setPropertiesData((prev: any) => [...prev, ...data.data]);
      if (data.data.length < 5) {
        setNoMoreData(true);
      }
    } else {
      setNoMoreData(true);
    }
    setIsFetchingNextPage(false);
  };

  useEffect(() => {
    getProperties(page);
  }, [shortlistedProperties, page]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        document.documentElement.clientHeight || window.innerHeight;

      const scrolledToBottom =
        Math.ceil(scrollTop + clientHeight) >= scrollHeight - 1300;

      if (scrolledToBottom && !isFetchingNextPage && !noMoreData) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isFetchingNextPage, noMoreData]);

  return (
    <>
      <DashboardLayout>
        {shortlistedProperties?.length > 0 ? (
          <div className="space-y-8 flex flex-col md:inline-block md:flex-none md:w-full  md:items-start  items-center">
            {propertiesData.map((property: any, index: number) => {
              return property?.property_listing_type == "auction-property" ? (
                <PropertyCard
                  className=" bg-brand-lightPink flex flex-col md:flex-row max-w-[358px] lg:flex-col mid:flex-row md:max-w-[951px] 2xl:lg:max-w-[1251px] lg:relative hover:shadow-lg hover:shadow-300 hover:duration-300 hover:ease-out clip-path-mobileClipPolygonTopRight md:clip-path-webClipPolygonTopRight"
                  imgClasses="lg:w-full mid:w-[293px]"
                  key={`property-${index}`}
                  propertyData={property}
                  assetPath={
                    property?.images.length > 0
                      ? getWatermarkedImgixUrl(
                          `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${
                            property?.images[0]?.path_to_file?.split(".com/")[1]
                          }`,
                        )
                      : property?.sub_asset_type_images.length > 0
                      ? getWatermarkedImgixUrl(
                          `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${property?.sub_asset_type_images[0].uuid}`,
                        )
                      : "/newPropertyImage.png"
                  }
                  showPrice={
                    property.property_date_type === "undated" ? false : true
                  }
                  price={amountFormatter(property.reserve_price)}
                  priceTag="reserve Price"
                  isTagged={property?.interested_count > 0}
                  showTagText={
                    property.property_date_type === "undated"
                      ? false
                      : property.property_date_type === "private_treaty"
                      ? false
                      : true
                  }
                  tag={
                    property.property_date_type === "undated"
                      ? "Coming Soon"
                      : property.property_date_type === "private_treaty"
                      ? "Private Treaty"
                      : undefined
                  }
                  tagNumber={property?.interested_count}
                  listingId={property?.listing_id}
                  location={`${property?.city?.name}, ${property?.state?.name}`}
                  propertyInfo={property.description}
                  propertyType={`${property?.asset?.name} / ${property?.sub_asset_type?.name}`}
                  carpetArea={property?.area || "N/A"}
                  deadlineDate={
                    property.property_date_type === "undated"
                      ? "Coming Soon"
                      : property.property_date_type === "private_treaty"
                      ? "Private Treaty"
                      : property?.emd_last_date &&
                        DateTime.fromISO(property?.emd_last_date)
                          .setZone("Asia/Kolkata")
                          .toFormat("dd MMMM yyyy")
                  }
                  sellerName={property?.bank?.name}
                  auctionDate={
                    property.property_date_type === "undated"
                      ? "Coming Soon"
                      : property.property_date_type === "private_treaty"
                      ? "Private Treaty"
                      : property?.auction_start_date_time &&
                        DateTime.fromISO(property?.auction_start_date_time)
                          .setZone("Asia/Kolkata")
                          .toFormat("dd MMMM yyyy")
                  }
                  isVerified={property.ab_verified}
                  isLiked={shortlistedProperties?.includes(property.uuid)}
                  whatsAppHandler={() => {}}
                  sortingHandler={() => {}}
                  contactHandler={() => {}}
                />
              ) : process.env.NEXT_PUBLIC_PYP_ENABLE === "true" ? (
                <PrivatePropertyCard
                  key={`property-${index}`}
                  propertyData={property}
                  assetPath={
                    property?.images.length > 0
                      ? `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${property?.images[0].uuid}`
                      : property?.sub_asset_type_images.length > 0
                      ? `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${property?.sub_asset_type_images[0].uuid}`
                      : "/newPropertyImage.png"
                  }
                  imgClasses={"object-cover"}
                  showPrice={true}
                  price={amountFormatter(
                    property?.reserve_price !== 0
                      ? property?.reserve_price
                      : property?.posted_properties_data
                          ?.base_price_proposed_last_rp
                      ? property?.posted_properties_data
                          ?.base_price_proposed_last_rp
                      : property?.posted_properties_raw_data?.propertyCost,
                  )}
                  priceTag="reserve Price"
                  isTagged={property?.interested_count > 0}
                  tagNumber={property?.interested_count}
                  listingId={property.listing_id}
                  location={`${property?.city?.name}, ${property?.state?.name}`}
                  propertyInfo={property.description}
                  propertyType={`${property?.asset?.name} / ${property?.sub_asset_type?.name}`}
                  carpetArea={
                    property?.posted_properties_raw_data?.landSize
                      ? property?.posted_properties_raw_data?.landSize
                      : property?.posted_properties_raw_data?.builtUpArea
                      ? property?.posted_properties_raw_data?.builtUpArea
                      : "N/A"
                  }
                  deadlineDate={
                    property.property_date_type === "undated"
                      ? "Coming Soon"
                      : property.property_date_type === "private_treaty"
                      ? "Private Treaty"
                      : property?.emd_last_date &&
                        DateTime.fromISO(property?.emd_last_date)
                          .setZone("Asia/Kolkata")
                          .toFormat("dd MMMM yyyy")
                  }
                  sellerName={property.dump?.bank?.bank_name}
                  sellerIcon={
                    property.dump?.bank?.bank_logo ? (
                      <img
                        src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${property.dump.bank.bank_logo}?w=32&h=32&auto=format`}
                      />
                    ) : undefined
                  }
                  auctionDate={
                    property.property_date_type === "undated"
                      ? "Coming Soon"
                      : property.property_date_type === "private_treaty"
                      ? "Private Treaty"
                      : property?.auction_start_date_time &&
                        DateTime.fromISO(property?.auction_start_date_time)
                          .setZone("Asia/Kolkata")
                          .toFormat("dd MMMM yyyy")
                  }
                  tag={undefined}
                  showTagText={true}
                  isVerified={property.ab_verified}
                  isLiked={shortlistedProperties?.includes(property.uuid)}
                  whatsAppHandler={() => {}}
                  sortingHandler={() => {}}
                  contactHandler={() => {}}
                />
              ) : (
                <></>
              );
            })}
            {isFetchingNextPage && (
              <div className="flex justify-center items-center">
                <div className="w-14 h-14 border-8 border-t-6 border-brand-orange rounded-full animate-spin bg-gradient-to-r from-brand-orange to-blue-100 shadow-lg"></div>
              </div>
            )}
          </div>
        ) : (
          <>
            <div className="font-spaceGrotesk font-normal text-mobile-subheading leading-4 lg:text-[30px] mid:text-[36px] text-center lg:mt-14  lg:leading-[48px]  lg:pl-[19px] py-2 lg:py-3   ">
              No Properties Shortlisted
            </div>
          </>
        )}
      </DashboardLayout>
    </>
  );
};

export default ShortlistedSection;
